module.exports = __webpack_public_path__ + "img/slide1_img4.f20e7079.png";